import { render, staticRenderFns } from "./CmpBuildForm.vue?vue&type=template&id=2b3d1e2e&scoped=true&"
import script from "./CmpBuildForm.vue?vue&type=script&lang=js&"
export * from "./CmpBuildForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d1e2e",
  null
  
)

export default component.exports